export default __webpack_public_path__ + "static/media/info-builder.7a416da2.svg";